import { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

let cache = null;
let pending = null;

function loadClientOptions() {
  if (!pending) {
    pending = axiosInstance
      .get("/client-options")
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.data) ? res.data.data : [];
        cache = raw.map((c) => ({
          id: String(c.Tenant_Id),
          name: c.Name,
          status: c.Status || "",
          isActive: String(c.Status || "").toLowerCase() === "active",
          domainId: c.Domain_Id != null ? String(c.Domain_Id) : "",
          domainName: c.Domain_Name || "",
        }));
        return cache;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/**
 * Every client (active + inactive) as [{id, name, status, isActive, domainId, domainName}].
 * Renders the last loaded list immediately and refetches on every mount so clients added or
 * edited since then show up without a full page reload.
 */
export default function useClientOptions() {
  const [clients, setClients] = useState(() => cache || []);
  useEffect(() => {
    let cancelled = false;
    loadClientOptions()
      .then((rows) => {
        if (!cancelled) setClients(rows);
      })
      .catch(() => {
        if (!cancelled && !cache) setClients([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return clients;
}
